import { GameSlingoParticleProperties } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/properties/GameSlingoParticlesProperties";
import { Point } from "pixi.js";
export class SlingoParticlesLandscapeProperties extends GameSlingoParticleProperties {
    constructor() {
        super();
        this.position.set(608, 98); //values from the GameTicket
    }
    getSpawnZone() {
        return GameSlingoParticleProperties.createSpawnZone(new Point(20, 17), 693, 849, 697);
    }
}
//# sourceMappingURL=SlingoParticlesLandscapeProperties.js.map